import SchoolExamPeriodDetailAPI from '@/apis/business/teacher/school-exam-period-detail-api.js'
import { Pagination } from '@/common/constant'
import Enumeration from '@/common/enumeration'
import ExamStoreAPI from '@/apis/business/teacher/exam-store-api.js'

export default {
  namespaced: true,

  state: {
    viewActive: Enumeration.SchoolExamPeriodView.CommonInformation,
    tabActive: Enumeration.ExamStatus.AssignComposing,
    examPeriodDetailCommonInformation: {},
    listStudent: [],
    listExamAlertDetail: [],
    examDetail: {},
    examStore: {},
    schoolExamPeriodDetails: [],
    schoolExamPeriodDetailsAssigned: [],
    tmpSchoolExamPeriodDetails: [],
    schoolExamPeriodDetail: {},
    total: null,
    openTopicResponses: [],
    updateStatusResponse: {},
    examPeriodDetailParams: [],
    timeNow: null,
    dataForMisssionOverview: [],
    examCodes: []
  },

  mutations: {
    // Active
    // CreateBy: VHSon 30.08
    updateViewActive (state, viewActive) {
      state.viewActive = viewActive
    },

    // Active
    // CreateBy: VHSon 23.03
    updateTabActive (state, tabActive) {
      state.tabActive = tabActive
    },

    /**
     * set Common Information
     * CreateBy: VHSON 06.09
     */
    setCommonInformation (state, examPeriodDetailCommonInformation) {
      state.examPeriodDetailCommonInformation =
        examPeriodDetailCommonInformation
    },

    /**
     * set list Student
     * CreateBy: VHSON 06.09
     */
    setListStudent (state, listStudent) {
      state.listStudent = listStudent
    },

    /**
     * set list Exam alert detail
     * CreateBy: BXHIEU 30/03/2022
     */
    setListExamAlertDetail (state, listExamAlertDetail) {
      state.listExamAlertDetail = listExamAlertDetail
    },

    /**
     * set Exam Detail
     * CreateBy: VHSON 06.09
     */
    setExamPeriodDetail (state, examDetail) {
      state.examDetail = examDetail
    },

    setAssignExam (state, isAssign) {
      state.examDetail.IsAssign = isAssign
    },

    setPeriodDetailParams (state, data) {
      state.examPeriodDetailParams = [...data]
    },

    /**
     * set Exam Detail
     * CreateBy: lhlong 18.10
     */
    setTimeNow (state, timeNow) {
      state.timeNow = timeNow
    },

    /**
     *
     * @description thay đổi state bằng ExamStore mới
     * @author lhlong
     */
    setExamStore (state, examStore) {
      state.examStore = examStore
    },

    /**
     * Clone dữ liệu kỳ đánh giá
     * @param {*} state
     * @param {*} data
     */
    setSchoolExamPeriodDetails (state, data) {
      state.schoolExamPeriodDetails = data || []
      state.tmpSchoolExamPeriodDetails = JSON.parse(JSON.stringify(state.schoolExamPeriodDetails))
      state.tmpSchoolExamPeriodDetails.forEach(element => {
        element.StartTime = element.StartTime ? new Date(element.StartTime) : undefined
        element.EndTime = element.EndTime ? new Date(element.EndTime) : undefined
      })
    },
    /**
     * Gán giá trị response sau khi mở, đóng đề
     * @param {*} state
     * @param {*} updateStatusResponse
     */
    setUpdateStatusResponse (state, updateStatusResponse) {
      state.updateStatusResponse = updateStatusResponse
    },

    /**
     * Gán giá trị response sau khi mở, đóng đề
     * @param {*} state
     * @param {*} openTopicResponses
     */
    setOpenTopicResponses (state, openTopicResponses) {
      state.openTopicResponses = openTopicResponses
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} quantityExam
     * @description set số lượng đề kiểm tra
     */
    setTotal (state, newValue) {
      state.total = newValue
    },

    updateSchoolExamPeriodDetail (state, dataSubmit) {
      const listSchoolExamPeriodDetail = state.schoolExamPeriodDetails
      listSchoolExamPeriodDetail.forEach((item, index) => {
        const changeItem = dataSubmit.find((x) => x.Id === item.Id)
        if (changeItem !== undefined) {
          state.schoolExamPeriodDetails.splice(index, 1)
          state.schoolExamPeriodDetails.splice(index, 0, changeItem)
        }
      })
      state.tmpSchoolExamPeriodDetails = JSON.parse(JSON.stringify(state.schoolExamPeriodDetails))
      state.tmpSchoolExamPeriodDetails.forEach(element => {
        element.StartTime = element.StartTime ? new Date(element.StartTime) : undefined
        element.EndTime = element.EndTime ? new Date(element.EndTime) : undefined
      })
    },
    /**
     * Cập nhật dữ liệu thay người dùng thay đổi
     * NVHUY1
     * @param {} state
     * @param {*} schoolExamDetail
     */
    updateSchoolExamDetail (state, schoolExamDetail) {
      state.tmpSchoolExamPeriodDetails.forEach(item => {
        if (item.Id === schoolExamDetail.Id) {
          item.TeacherComposeID = schoolExamDetail.TeacherComposeID
          item.TeacherComposeName = schoolExamDetail.TeacherComposeName
          item.Time = schoolExamDetail.Time
          item.TimePeriod = schoolExamDetail.TimePeriod
          item.StartTime = schoolExamDetail.StartTime
          item.EndTime = schoolExamDetail.EndTime
        }
      })
    },

    /**
     * Cập nhật lại dữ liệu khi hủy thay đổi
     * @param {} state
     */
    resetData (state) {
      state.tmpSchoolExamPeriodDetails = JSON.parse(JSON.stringify(state.schoolExamPeriodDetails))
      state.tmpSchoolExamPeriodDetails.forEach(element => {
        element.StartTime = element.StartTime ? new Date(element.StartTime) : undefined
        element.EndTime = element.EndTime ? new Date(element.EndTime) : undefined
      })
    },

    /**
     * @author PVThang
     * @description set schoolExamPeriodDetailsAssigned
     */
    setSchoolExamPeriodDetailsAssigned (state, data) {
      state.schoolExamPeriodDetailsAssigned = data
    },

    /**
     * @author VHSON
     * @description set dataForMisssionOverview
     */
    setDataForMisssionOverview (state, data) {
      state.dataForMisssionOverview = data
    }

  },

  actions: {
    /**
     * @author lhlong
     * @desciption update clock count down
     */
    async updateClockCountDown (context, params) {
      await context.commit('setTimeNow', params)
    },

    /**
     * Cập nhật danh sách kỳ đánh giá theo môn học
     */
    updateSchoolExamPeriodDetail (context, schoolExamPeriodDetails) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.putAsync('detail', schoolExamPeriodDetails)
          .then((res) => {
            context.commit(
              'updateSchoolExamPeriodDetail',
              schoolExamPeriodDetails
            )

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách kỳ đánh giá
     * @param {*} context
     * @param {*} param
     * NVHUY1 04/09/2021
     */
    getSchoolExamPeriodDetails (context, param) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(
          `school-exam-periods/${param.SchoolExamPeriodID}`
        )
          .then((res) => {
            context.commit('setSchoolExamPeriodDetails', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy thông tin chung bài kiểm tra theo examPeriodDetailID
     * @author VHSon
     * @param {*} examPeriodDetailID
     * @param {*} context
     * @returns
     */
    getExamPeriodDetailCommonInformationById (context, examPeriodDetailID) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(
          `/common-information?examPeriodDetailId=${examPeriodDetailID}`
        )
          .then((res) => {
            context.commit('setCommonInformation', res?.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy thông tin chi tiết bài kiểm tra theo examPeriodDetailID
     * @author VHSon
     * @param {*} examPeriodDetailID
     * @param {*} context
     * @returns
     */
    getExamPeriodDetailById (context, examPeriodDetailID) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(
          `/detail?examPeriodDetailId=${examPeriodDetailID}`
        )
          .then((res) => {
            context.commit('setExamPeriodDetail', res?.Data)
            context.commit('setUpdateStatusResponse', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học sinh theo lớp, môn học và bài kiểm tra
     * @author VHSon
     * @param {*} examPeriodId
     * @param {*} classId
     * @param {*} context
     * @returns
     */
    getlistStudentByExamId (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync('student-detail', { params }).then((res) => {
          context.commit('setListStudent', res?.Data)
          resolve(res.Data)
        }).catch((err) => {
          reject(err)
        })
      })
    },

    /**
     * Lấy danh sách chi tiết cảnh cáo kỳ thi
     * @author VHSon
     * @param {*} examPeriodId
     * @param {*} classId
     * @param {*} context
     * @returns
     * BXHIEU 30/03/2022
     */
    getlistExamAlertDetailByID (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync('exam-alert-detail', { params }).then((res) => {
          context.commit('setListExamAlertDetail', res?.Data)
          resolve(res.Data)
        }).catch((err) => {
          reject(err)
        })
      })
    },

    /**
     * Lấy danh sách học sinh khi ấn nút refresh ở màn giám sát
     * @author VHSon
     * @param {*} examPeriodId
     * @param {*} subjectId
     * @param {*} classId
     * @param {*} context
     * @returns
     */
    refreshDataStudents (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(
          '/refresh', { params }
        )
          .then((res) => {
            context.commit('setListStudent', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API để lấy ExamStore của môn trong từng kì kiểm tra
     * @author lhlong
     */
    getExamStoreByPeriodDetailID (context, param) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(`/exam-store/${param}`)
          .then((res) => {
            context.commit('setExamStore', res.Data)

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Gọi API để lấy ExamStore của môn trong từng kì kiểm tra theo mã đề(nếu đề có trộn)
     * @author VHSON
     */
    getExamStoreByPeriodAndSortOrderID (context, param) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.getAsync('detail?id=' +
        param.Id +
        '&sortOrder=' +
        param.SortOrder)
          .then((res) => {
            context.commit('setExamStore', res.Data)

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật trạng thái mở đóng đề
     * @author VHSon
     * @param {*} context
     * @param {*} examPeriodId
     * @param {*} Status
     * @returns
     */
    updateExamPeriodStatus (context, updateStatusParams) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.putAsync('update-status', updateStatusParams)
          .then((res) => {
            context.commit('setUpdateStatusResponse', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} params
     * @description Lấy danh sách
     */
    async getSchoolExamPeriodDetailIsAssigns (context, params) {
      const res = await SchoolExamPeriodDetailAPI.getAsync('is-assigned', {
        params: params
      })
      const data = res?.Data
      const examAssigns = params.pageIndex === Pagination.PageIndexDefault
        ? data?.PageData
        : [...(context.state.schoolExamPeriodDetailsAssigned || []), ...(data?.PageData || [])]
      context.commit('setSchoolExamPeriodDetailsAssigned', examAssigns)
      context.commit('setTotal', data?.Total)

      return res
    },

    /**
     * @author VHSON
     * @param {*} context
     * @param {*} params
     * @description Lấy danh sách nhiệm vụ màn hình tổng quan
     */
    getDataForMisssionOverview (context, params) {
      const query =
      `schoolYear=${params}`
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(`mission-overview?${query}`)
          .then((res) => {
            context.commit('setDataForMisssionOverview', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật trạng thái mở đóng đề
     * @author VHSon
     * @param {*} context
     * @param {*} openTopicsParams
     * @returns
     */
    openTopicsFromOverview (context, openTopicsParams) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.postAsync(
          'open-topics', openTopicsParams
        )
          .then((res) => {
            context.commit('setOpenTopicResponses', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getByIdSchoolExamPeriodDetail (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(params).then((res) => {
          context.commit('setExamPeriodDetail', res?.Data)
          resolve(res.Data)
        }).catch((err) => {
          reject(err)
        })
      })
    }
  }
}
